module.exports = __webpack_public_path__ + "img/snail.71b88e8c.svg";